import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckoutGuardService } from './core/services/checkout-guard.service';
import { GuardService } from './core/services/guard.service';
import { QuoteViewerService } from './core/services/quote-viewer.service';
import { AppLoginComponent } from './modules/commandCenter/app.login.component';
import { UserClaimComponent } from './modules/commandCenter/user/user-claim/user-claim.component';
import { UserPasswordResetComponent } from './modules/commandCenter/user/user-password-reset/user-password-reset.component';
import { EmailViewComponent } from './modules/customer-marketing/email-view/email-view.component';
import { UnsubscribeComponent } from './modules/customer-marketing/unsubscribe/unsubscribe.component';
import { AboutMeComponent } from './modules/customer/about-me/about-me.component';
import { DefaultComponent } from './modules/default/default.component';
import { HostComponent } from './modules/host/host.component';
import { CheckOutComponent } from './modules/online-order/check-out/check-out.component';
import { OnboardingComponent } from './modules/online-order/onboarding/onboarding.component';
import { PublicComponent } from './modules/public/oauth/public/public.component';
import { VenueNotFoundComponent } from './modules/public/venue-not-found/venue-not-found.component';
import { QuoteCompletePaymentProfileComponent } from './modules/quote-viewer/quote-complete-payment-profile/quote-complete-payment-profile.component';

const routes: Routes = [
	{
		path: '',
		component: DefaultComponent,
	},
	{
		path: 'login',
		loadChildren: () => import('./modules/user-login/user-login-routing.module').then((m) => m.UserLoginRoutingModule),
	},
	{
		path: 'cc',
		canActivate: [GuardService],
		loadChildren: () => import('./modules/commandCenter/command-center.module').then((m) => m.CommandCenterModule),
	},
	{
		path: 'user',
		children: [
			{
				path: 'claim',
				component: UserClaimComponent,
			},
			{
				path: 'passwordreset',
				component: UserPasswordResetComponent,
			},
		],
	},
	{
		path: 'receipts/:token',
		loadChildren: () => import('./modules/mobile-pay/mobile-pay.module').then((m) => m.MobilePayModule),
	},
	{
		path: ':venueKey/emb',
		children: [
			{
				path: 'e',
				component: EmailViewComponent,
			},
			{
				path: 'unsub',
				component: UnsubscribeComponent,
			},
		],
	},
	{
		path: ':venueKey/gift',
		loadChildren: () => import('./modules/gift/gift.module').then((m) => m.GiftModule),
	},
	{
		path: ':venueKey/kiosk',
		loadChildren: () => import('./modules/kiosk/kiosk.module').then((m) => m.KioskModule),
	},
	{
		path: ':venueKey/pos',
		loadChildren: () => import('./modules/pos/pos.module').then((m) => m.PosModule),
	},
	{
		path: ':venueKey/subscriptions',
		loadChildren: () => import('./modules/subscription/subscription.module').then((m) => m.SubscriptionModule),
	},
	{
		path: ':venueKey/survey',
		loadChildren: () => import('./modules/survey/survey.module').then((m) => m.SurveyModule),
	},
	{
		path: ':venueKey/host',
		component: HostComponent,
	},
	{
		path: 'onboard',
		component: OnboardingComponent,
	},
	{
		path: 'aboutme',
		component: AboutMeComponent,
	},
	{
		path: 'quote',
		loadChildren: () => import('./modules/quote-viewer/quote-viewer.module').then((m) => m.QuoteViewerModule),
	},
	{
		path: 'quote/:quoteId/complete',
		component: QuoteCompletePaymentProfileComponent,
		canActivate: [QuoteViewerService],
	},
	{
		path: 'e/404',
		component: VenueNotFoundComponent,
	},
	{
		path: 'focuspay',
		loadChildren: () => import('./modules/focuspay/focuspay.module').then((m) => m.FocuspayModule),
	},
	{
		path: ':storeKey',
		// component: OnlineOrderComponent,
		loadChildren: () => import('./modules/online-order/online-order.module').then((m) => m.OnlineOrderModule),
	},
	{
		path: ':storeKey/admin',
		component: AppLoginComponent,
	},
	{
		path: ':storeKey/admin/oauth',
		component: PublicComponent,
	},
	{
		path: ':storeKey/checkout',
		canActivate: [CheckoutGuardService],
		component: CheckOutComponent,
	},
	{
		path: 'integrations/oauth/callback',
		component: PublicComponent,
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
